"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[MeetingSessionURLs]] contains the URLs that will be used to reach the
 * meeting service.
 */

var MeetingSessionURLs = /*#__PURE__*/function () {
  function MeetingSessionURLs() {
    _classCallCheck(this, MeetingSessionURLs);

    /**
     * The audio host URL of the session
     */
    this._audioHostURL = null;
    /**
     * The screen data URL of the session
     */

    this._screenDataURL = null;
    /**
     * The screen sharing URL of the session
     */

    this._screenSharingURL = null;
    /**
     * The screen viewing URL of the session
     */

    this._screenViewingURL = null;
    /**
     * The signaling URL of the session
     */

    this._signalingURL = null;
    /**
     * The TURN control URL of the session
     */

    this._turnControlURL = null;
    /**
     * The event ingestion URL to send the meeting events.
     */

    this._eventIngestionURL = null;
    /**
     * Function to transform URLs. Use this to rewrite URLs to traverse proxies.
     * The default implementation returns the original URL unchanged.
     */

    this.urlRewriter = function (url) {
      return url;
    };
  }
  /**
   * Gets or sets the audio host URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
   */


  _createClass(MeetingSessionURLs, [{
    key: "audioHostURL",
    get: function get() {
      return this.urlRewriter(this._audioHostURL);
    },
    set: function set(value) {
      this._audioHostURL = value;
    }
    /**
     * Gets or sets the screen data URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */

  }, {
    key: "screenDataURL",
    get: function get() {
      return this.urlRewriter(this._screenDataURL);
    },
    set: function set(value) {
      this._screenDataURL = value;
    }
    /**
     * Gets or sets the screen sharing URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */

  }, {
    key: "screenSharingURL",
    get: function get() {
      return this.urlRewriter(this._screenSharingURL);
    },
    set: function set(value) {
      this._screenSharingURL = value;
    }
    /**
     * Gets or sets the screen viewing URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */

  }, {
    key: "screenViewingURL",
    get: function get() {
      return this.urlRewriter(this._screenViewingURL);
    },
    set: function set(value) {
      this._screenViewingURL = value;
    }
    /**
     * Gets or sets the signaling URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */

  }, {
    key: "signalingURL",
    get: function get() {
      return this.urlRewriter(this._signalingURL);
    },
    set: function set(value) {
      this._signalingURL = value;
    }
    /**
     * Gets or sets the TURN control URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */

  }, {
    key: "turnControlURL",
    get: function get() {
      return this.urlRewriter(this._turnControlURL);
    },
    set: function set(value) {
      this._turnControlURL = value;
    }
    /**
     * Gets or sets the events ingestion URL with gets reflecting the result of the {@link MeetingSessionURLs.urlRewriter} function.
     */

  }, {
    key: "eventIngestionURL",
    get: function get() {
      return this.urlRewriter(this._eventIngestionURL);
    },
    set: function set(value) {
      this._eventIngestionURL = value;
    }
  }]);

  return MeetingSessionURLs;
}();

exports.default = MeetingSessionURLs;